<template>
  <!-- 自定义套餐 -->
  <div class="packageWrap" v-if="serviceList.length > 0">
    <div class="packageLeft">
      <p class="fs14 fwb mb6" v-if="businessType == 'COMPANY_INCORPORATION'">Customize - Incorporation</p>
      <p class="fs14 fwb mb6" v-if="businessType == 'SERVICE_TRANSFER'">Customize - Service Transfer</p>
      <p>
        <span class="fs20 fwb orange">{{ serviceListPriceSum(serviceList, serviceList[0].currency) }}</span>
      </p>
      <div class="pt10">
        <!-- 适用人群 -->
        <p class="fs12">Exclusive for:</p>
        <p class="fs12 black88">Customers who wish to choose services flexibly.</p>
      </div>
    </div>
    <div class="packageRight">
      <div class="flex flex-direction-row details">
        <div class="mr20">
          <!-- 套餐包含： -->
          <p class="fs12 fwb">Package Includes:</p>
          <ul class="fs12 black45 lh22">
            <li v-for="son in serviceList" :key="`son-${son.id}`">
              <span class="fwb green fs12 el-icon-check"></span>
              {{ son.description }}
              <span v-if="$isNumberLike(son.serviceFee)">({{ currencyAndAmountFormat(son.currency, son.serviceFee) }})</span>
              <el-popover placement="bottom" trigger="hover" v-if="son.serviceScope">
                <span class="fs12">{{ son.serviceScope }}</span>
                <span slot="reference" class="ml2 fs13 blackD8 el-icon-question"></span>
              </el-popover>
            </li>
          </ul>
        </div>
        <!-- 第三方费用 -->
        <div class="mr20">
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            Third Party Fee:
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="part in mergeSameAttrList(serviceList, 'thirdPartyFeeDescription', 'thirdPartyFee')" :key="`part-${part.id}`">
              <span v-if="part.thirdPartyFeeDescription">- {{ part.thirdPartyFeeDescription }}</span>
              <span v-if="$isNumberLike(part.thirdPartyFee)">({{ currencyAndAmountFormat(part.currency, part.thirdPartyFee) }})</span>
            </li>
          </ul>
        </div>
        <!-- 其他费用 -->
        <div>
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            Other Fee:
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="other in mergeSameAttrList(serviceList, 'otherFeeDescription', 'otherFee')" :key="`other-${other.id}`">
              <span v-if="other.otherFeeDescription">- {{ other.otherFeeDescription }}</span>
              <span v-if="$isNumberLike(other.otherFee)">({{ currencyAndAmountFormat(other.currency, other.otherFee) }})</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import priceCountMixin from "@/mixins/priceCountMixin";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [priceCountMixin, formatterMixin],
  props: {
    businessType: {
      type: String,
      default: () => "",
    },
    goodsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    serviceList() {
      const list = this.goodsList?.map(item => item.service) || [];
      return list;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.packageWrap {
  display: flex;
  width: 100%;
  padding: 16px;
  background-color: #fdf6ec;

  .packageLeft {
    padding-right: 16px;
    max-width: 250px;
  }

  .packageRight {
    padding-left: 16px;
    border-left: 1px solid #e4e7ed;
  }

  p {
    line-height: 20px;
    margin: 0;
    color: #011a45;
  }
}
</style>
